import React from "react";
import "./MainContent.css"

export default function User(){
    return(
        <div className="maincontent maindiv" >
            <h3>
                Page Under construction
            </h3>
        </div>
    )
}